import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import '../../css/Dashboard.css';
import { useDashboardData } from '../SalesDashboard/DashboardDataContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ByAssigneeChart: React.FC = () => {
  const [data, setData] = useState<any>({ labels: [], datasets: [] });
  const { data: dash } = useDashboardData();
  useEffect(() => {
    if (!dash) return;
    if (dash.queriesByAssignee && dash.queriesByAssignee.length > 0) {
      const labels = dash.queriesByAssignee.map(x => x.assigneeName);
      const counts = dash.queriesByAssignee.map(x => x.count);
      setData({ labels, datasets: [{ label: 'Queries', data: counts, backgroundColor: '#86efac' }] });
      return;
    }
    const map: Record<string, number> = {};
    (dash.queries||[]).forEach((q:any)=>{ const a=q.assignedTo?.name || 'Unassigned'; map[a]=(map[a]||0)+1; });
    const labels = Object.keys(map);
    const counts = labels.map(l => map[l]);
    setData({ labels, datasets: [{ label: 'Queries', data: counts, backgroundColor: '#86efac' }] });
  }, [dash]);

  return (
    <div className="card">
      <h4 className="card-title">By Assignee</h4>
      <Bar data={data} />
    </div>
  );
};

export default ByAssigneeChart;
